import { Link } from "react-router-dom";
import { categoryList } from "@/mocks/comics";

const quickLinks = [
  { name: "热门连载", path: "/category/all?sort=hot" },
  { name: "最新更新", path: "/category/all?sort=new" },
  { name: "已完结", path: "/category/all?sort=done" },
  { name: "关于我们", path: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-secondary-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          {/* Brand */}
          <div className="max-w-sm">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="漫天堂 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                漫<span className="text-primary-600">天堂</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              漫天堂是漫画爱好者的阅读与索引平台，聚合热门连载、经典旧作与最新更新，支持分类浏览与站内检索，一站式发现你喜欢的作品。
            </p>
          </div>

          {/* Categories */}
          <nav className="grid grid-cols-2 gap-x-12 gap-y-2 sm:grid-cols-3" aria-label="分类导航">
            <h4 className="col-span-full mb-1 text-sm font-semibold text-foreground-950">
              <a href="#categories">漫画分类</a>
            </h4>
            {categoryList
              .filter((c) => c.key !== "all")
              .map((c) => (
                <Link
                  key={c.key}
                  to={`/category/${c.key}`}
                  className="flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-600"
                >
                  <i className={`${c.icon} text-xs`} />
                  {c.name}
                </Link>
              ))}
          </nav>

          {/* Quick links */}
          <nav className="flex flex-col gap-2" aria-label="快捷入口">
            <h4 className="mb-1 text-sm font-semibold text-foreground-950">
              <a href="#quick-links">快捷入口</a>
            </h4>
            {quickLinks.map((l) => (
              <Link
                key={l.name}
                to={l.path}
                className="text-sm text-foreground-600 hover:text-primary-600"
              >
                {l.name}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 漫天堂 Mantiantang. 本站内容仅供学习交流，请勿用于商业用途。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <Link to="/about" className="hover:text-primary-600">联系我们</Link>
            <span>·</span>
            <Link to="/about" className="hover:text-primary-600">版权声明</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}